<template>
	<div class="add-dict-type">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="addOrEdit ? $t('addDictType.add') : $t('addDictType.edit')"
			:visible.sync="dialogDict"
			width="30%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="dictForm"
					label-width="80px"
					:model="dictForm">
					<el-form-item
						:label="$t('addDictType.dictName')"
						prop="name"
						:error="error.name">
						<el-input
							v-model="dictForm.name"
							:placeholder="$t('addDictType.pDictName')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item
						:label="$t('addDictType.dictType')"
						prop="type"
						:error="error.type">
						<el-input
							v-model="dictForm.type"
							:placeholder="$t('addDictType.pDictType')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('addDictType.notes')">
						<el-input
							type="textarea"
							:rows="4"
							v-model="dictForm.notes"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('dictForm')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddDictType",
	data() {
		let typeYz = (rule, value, callback) => {
			const reg = new RegExp(/^[a-z][a-z_]+$/);
			if (!reg.test(value)) {
				callback(new Error(this.$t("addDictType.vDictType")));
			}
		};
		return {
			labelPosition: "top",
			loadingForm: false,
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addDictType.pDictName"),
						trigger: "change",
					},
					{
						min: 2,
						max: 16,
						message: this.$t("addDictType.vDictName"),
						trigger: "change",
					},
				],
				type: [{ validator: typeYz, required: true, trigger: "change" }],
			},
			error: {
				name: "",
				type: "",
			},
			defaulttype: "",
			clear: false,
		};
	},
	props: {
		addOrEdit: Boolean,
		dialogDict: Boolean,
		dictForm: Object,
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		closeDialog() {
			this.clearValidate("dictForm");
			if (!this.addOrEdit) {
				this.$toolUtil.clearForm(this.dictForm);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.dictForm);
				}
			}
			this.cancel();
		},

		openDialog() {
			this.defaulttype = this.dictForm.type;
		},
		submitForm() {
			this.loadingForm = true;
			let url = this.$url.DictType.save;
			let method = this.$method.post;
			if (this.dictForm.id) {
				url = this.$url.DictType.update;
				method = this.$method.put;
			}
			this.$api
				.request(url, method, this.dictForm)
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: this.dictForm.id
								? this.$t("addDictType.up")
								: this.$t("addDictType.save"),
							type: "success",
						});
						this.clear = true;
						this.cancel(this.dictForm.id ? "update" : "save");
					}
					this.loadingForm = false;
				})
				.catch(() => {
					this.loadingForm = false;
				});
		},

		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},

		// 清除表单校验信息
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style scoped></style>
